require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-aus-design-review-2024-bathroom-trend.json") })
        }
      }, "path---journal-aus-design-review-2024-bathroom-trend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-aus-design-review-2024-bathroom-trend!./.cache/json/journal-aus-design-review-2024-bathroom-trend.json
// module id = 456
// module chunks = 231608221292675